import { NavLink } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';
import { isPharmacyDemo } from '../../demo';

const baseTabs = [
  { to: '/home', label: 'Home', icon: '/bottomTabs/home.svg' },
  { to: '/nutrition', label: 'Nutrition', icon: '/bottomTabs/nutrition.svg' },
  { to: '/workouts', label: 'Exercise', icon: '/bottomTabs/exercise.svg' },
  { to: '/body-stats', label: 'Body', icon: '/bottomTabs/bodyStats.svg' },
  { to: '/functional-age', label: 'Age', icon: '/bottomTabs/age.svg' },
];

const glp1HubTab = { to: '/glp1-hub', label: 'GLP 1-Hub', icon: '/bottomTabs/glp1-hub.svg' };

export function BottomNav() {
  const { isDemoMode, glp1Enabled, glp1CheckComplete } = useAppContext();

  // Build tabs array - only include GLP-1 Hub if enabled
  const tabs = glp1CheckComplete && glp1Enabled 
    ? [...baseTabs, glp1HubTab]
    : baseTabs;

  return (
    <nav 
      className="fixed inset-x-0 z-50 flex items-center justify-center px-4 bg-transparent"
      style={{ 
        bottom: 0,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="mx-auto max-w-md w-full">
        <div 
          className="backdrop-blur-[6px] backdrop-filter bg-[#141517] rounded-[10px] px-2.5 py-2 shadow-[0px_2px_6px_0px_rgba(0,0,0,0.02)]"
        >
          <div className="flex items-center justify-between">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={isDemoMode ? `${tab.to}?demo=1${isPharmacyDemo() ? '&partner=pharmacy' : ''}` : tab.to}
              className={({ isActive }) =>
                [
                  'flex flex-col items-center justify-center gap-0.5 flex-1 min-w-0',
                  isActive ? 'text-white' : 'text-[#636363]',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <div
                    className={[
                      'flex h-7 w-7 items-center justify-center rounded-[28px] shadow-[0px_1.5px_4px_0px_rgba(0,0,0,0.02)] flex-shrink-0',
                      isActive
                        ? 'bg-[#007c86]'
                        : 'bg-[rgba(245,245,245,0.1)]',
                    ].join(' ')}
                  >
                    <img
                      src={tab.icon}
                      alt={tab.label}
                      className={`h-3.5 w-3.5 flex-shrink-0 ${isActive ? 'brightness-0 invert' : ''}`}
                    />
                  </div>
                  <span className="text-[11px] font-medium tracking-[-0.15px] leading-tight text-center whitespace-nowrap">
                    {tab.label}
                  </span>
                </>
              )}
            </NavLink>
          ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
